// extracted by mini-css-extract-plugin
module.exports = {"dynamicSizeButton":"buttons-module__dynamicSizeButton___c9UGh","blueButton":"buttons-module__blueButton___1PzpW","greyButton":"buttons-module__greyButton___1VnPp"};